export default "assets/images/menu-bg-71c0658c.png";